import { useState } from "react";
import axios from "axios";
import { useAuth, API_URL } from "../App";

export default function AuthPage() {
  const { login } = useAuth();
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const endpoint = isLogin ? "/auth/login" : "/auth/signup";
      const payload = isLogin ? { email, password } : { email, password, name };
      const { data } = await axios.post(`${API_URL}${endpoint}`, payload);
      // Backend sets httpOnly cookie natively. We just populate user Context!
      login(data.user);
    } catch (err) {
      setError(err.response?.data?.error || "An error occurred");
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2 style={{textAlign: "center", marginBottom: 10, color: "var(--color-text)", fontWeight: 800}}>⚡ AutoFlow</h2>
        <h3 style={{fontSize: 18, marginBottom: 10, color: "var(--color-text)"}}>{isLogin ? "Welcome Back" : "Create Account"}</h3>
        {error && <div style={{ color: "var(--color-accent)", fontSize: 13, background: "#f781661a", padding: "10px", borderRadius: 6 }}>{error}</div>}
        <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          {!isLogin && (
            <input className="input-field" placeholder="Full Name" value={name} onChange={e=>setName(e.target.value)} required />
          )}
          <input className="input-field" type="email" placeholder="Email" value={email} onChange={e=>setEmail(e.target.value)} required />
          <input className="input-field" type="password" placeholder="Password" value={password} onChange={e=>setPassword(e.target.value)} required />
          <button type="submit" className="btn btn-primary" style={{ padding: "10px", fontSize: 14 }}>
            {isLogin ? "Sign In" : "Sign Up"}
          </button>
        </form>
        <div style={{ textAlign: "center", fontSize: 12, color: "var(--color-muted)", marginTop: 10 }}>
          {isLogin ? "Don't have an account? " : "Already have an account? "}
          <span style={{ color: "var(--color-accent)", cursor: "pointer", fontWeight: "bold" }} onClick={() => { setIsLogin(!isLogin); setError(""); }}>
            {isLogin ? "Register here" : "Login here"}
          </span>
        </div>
      </div>
    </div>
  );
}
